<h2 mat-dialog-title mat-dialog-draggable-title>{{'department_manage.config' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
<mat-card>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-dialog-content>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <form #f="ngForm" style="padding-top: 10px;">
            <div class="row col-lg-10 ml-4">
                <mat-form-field class="mat-full-width">
                  <input type="text" #focusInput matInput
                        (input)="onFilterData()"
                         [placeholder]="'department_manage.dialog_view.email_placeholder' | translate" name="name"
                         maxlength="200" [(ngModel)]="department.nameOrCode" autocomplete="off"/>
                         <button mat-button *ngIf="department.nameOrCode" type="button" matSuffix mat-icon-button aria-label="Clear"
                         (click)="department.nameOrCode=''; onFilterData()">
                         <mat-icon>close</mat-icon>
                       </button>
                </mat-form-field>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
            <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
                <span>{{'department_manage.dialog_view.list_user' | translate}} ({{paginate.totalRow}})</span>
              </mat-panel-title>
            <div class="mat-table-container">
                <mat-table [dataSource]="dataSource">
                    <!--STT-->
                    <ng-container matColumnDef="STT">
                        <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                        {{'department_manage.dialog_view.no' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                        <!-- {{ paginate.no[dataSource.filteredData.indexOf(element)] }} -->
                        {{element.STT}}
                        </mat-cell>
                    </ng-container>

                    <!-- Họ tên-->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                        {{'department_manage.dialog_view.name' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                                matTooltip="{{ element.fullName }}">
                        <span class="fix-width fw-100">{{ element.fullName }}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Email-->
                    <ng-container matColumnDef="email">
                        <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                        {{'department_manage.dialog_view.email' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                        matTooltip="{{ element.email + (element.userPosition ? ( ' - ' + element.userPosition) : '')}}">
                        <span class="fix-width fw-100">{{element.email}} <span *ngIf="element.userPosition">- {{element.userPosition}}</span></span> 
                        </mat-cell>
                    </ng-container>

                    <!-- Người đại diện phòng ban -->
                    <ng-container matColumnDef="representative">
                      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom" style="max-width: 18%;">
                      {{'search_form.department_representative' | translate}}
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col" (click)="$event.stopPropagation()" style="max-width: 18%;">
                <nz-switch [(ngModel)]="element.isRepresentative" (click)="changeRepresentative(element)" [nzControl]="true"></nz-switch>
              </mat-cell>
                  </ng-container>

                    <!-- Thao tác-->
                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom" style="max-width: 18%;">
                        {{'department_manage.dialog_view.action' | translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom" style="max-width: 18%;">
                        <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{'popup.confirm_delete_user' | translate}}"
                        (nzOnConfirm)="deleteUserDepartment(element)" [nzIcon]="iconDel"
                        nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                       <i class="fa fa-trash" aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                     </a>
                     <ng-template #iconDel>
                       <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                     </ng-template>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>
            <!-- Pagination -->
          <app-pagination [(paginate)]="paginate" [isShowChangeRecordOfPage]="false" (pageChange)="onFilterData($event.page, $event.pageSize)">
          </app-pagination>
        </mat-expansion-panel>
        </mat-accordion>

        <!-- Button thêm người dùng thuộc phòng ban -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel expanded="true" class="mt-3">
            <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
              <button mat-raised-button cdkFocusInitial color="primary" (click)="addUser()" [disabled]="!checkActive">
                <mat-icon class="mr-0">person_add</mat-icon>
               {{'title.assign_user_department' | translate}}
              </button>
            </mat-panel-title>

            <!-- Thêm người dùng thuộc phòng ban -->
            <div *ngIf="checkAddUser">
              <span class="ant-upload pb-2" style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">
                {{'search_form.department_user' | translate}}
              </span>
              <div>
                <nz-input-group [nzSuffix]="suffixUserInput">
                <input nz-input [(ngModel)]="inputUserValue"
                       (input)="onChangeUserSignSearch($event)" 
                       [nzAutocomplete]="autoUserSearching"
                       [ngModelOptions]="{ standalone: true }"
                       placeholder="{{'search_form.department_search_placeholder' | translate}}" id="inputUser" maxlength="200"/>
                <nz-autocomplete #autoUserSearching>
                  <nz-auto-option *ngFor="let user of filteredUserOptions"
                                  (selectionChange)="autocompleteUserSelected($event, user)"
                                  [nzValue]="''">{{user.fullName}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span>
                  </nz-auto-option>
                </nz-autocomplete>
                </nz-input-group>
                <ng-template #suffixUserInput>
                  <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                </ng-template>
                <ng-template #indicatorUserInput>
                  <i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px;"></i>
                </ng-template>
              </div>
          </div>
        </mat-expansion-panel>
     </mat-accordion>
    </mat-dialog-content>
</mat-card-content>
</mat-card>
